export default {
  faqOfferTitle: {
    id: 'buyback_swap_offer_faq_offer_title',
    defaultMessage: 'How are offers calculated?',
  },
  faqOfferDescription: {
    id: 'buyback_swap_offer_faq_offer_description',
    defaultMessage:
      'Each of the 250 refurbishers in our network has a wishlist of devices they’re looking to source including how much they’re willing to pay for each model. Using your assessment, we match your item with the highest offer.',
  },
  faqDataTitle: {
    id: 'buyback_swap_offer_faq_data_title',
    defaultMessage: 'Is my personal data safe?',
  },
  faqDataDescription: {
    id: 'buyback_swap_offer_faq_data_description',
    defaultMessage:
      'Yes! Once the refurbisher receives your trade-in device, they’ll immediately do a full factory reset, deleting all apps and data. We’ll also remind you about how to transfer and delete your data before shipping your device.',
  },
}
